/* tslint:disable:indent */
export class EnumToolsService {

  constructor() {
  }

  public static enumContainsString(e: any, v: string) {
    if (Object.values(e).includes(v)) {
      return true;
    }
    return false;
  }

  public static getValues(e: any): Array<string> {
    let array: Array<string> = [];
    for (let id in Object.values(e)) {
      if (typeof e[id] === 'string') {
        array.push(e[id]);
      }
    }
    return array;
  }

}
